module.exports = __webpack_public_path__ + "fonts/FSSinclair-Regular.126d9abd.otf";